import { Box, Text, Button } from '@betty/moonlight';
import { memo, useCallback, useEffect, useState } from 'react';
import {
  BottomSheet,
  Screen,
  useFocusEffect,
  useNavigation,
} from '@betty/navigation';
import { useTranslation } from '@betty/i18n';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import PeriodSelect from '../../components/ResponsibleGaming/components/PeriodSelect/PeriodSelect';
import { isUserOnBreak } from '../../state';
import { fetchLImits } from '../../components/ResponsibleGaming/state';

function TimeoutScreen() {
  const dispatch = useDispatch();
  const { t } = useTranslation('responsibleGaming');
  const navigation = useNavigation();

  const isTimedOut = useSelector(isUserOnBreak);

  useEffect(() => {
    navigation.setOptions({ title: t('timeout') });
  }, [navigation, t]);

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchLImits());
    }, [dispatch]),
  );

  const [period, setPeriod] = useState<string | null>(null);

  const onSubmitPress = useCallback(() => {
    BottomSheet.open({
      namespace: 'account',
      type: 'Timeout',
      titleNS: 'responsibleGaming',
      titleKey: 'timeoutTitleBottomSheet',
      data: {
        value: period,
      },
    });
  }, [period]);

  return (
    <Screen>
      <Box marginTop="space-400">
        <Text
          variant="body-m-semi"
          locNS="responsibleGaming"
          locKey="timeoutTitle"
          color="darkSurfacePrimary"
        />

        <Box gap="space-200">
          <PeriodSelect
            type="Timeout"
            disabled={isTimedOut}
            setValue={setPeriod}
          />

          <Text
            variant="body-m-semi"
            locNS="responsibleGaming"
            locKey="timeoutWarning"
            color="darkSurfacePrimary"
          />
        </Box>
        <Button
          variant="secondary"
          onPress={onSubmitPress}
          locNS="responsibleGaming"
          locKey="submitRequest"
          disabled={isTimedOut || !period}
          marginTop="space-600"
        />
      </Box>
    </Screen>
  );
}

export default memo(TimeoutScreen);
